// extracted by mini-css-extract-plugin
export default {"buttonContainer":"styles_buttonContainer__jr3lm","button":"styles_button__PQiyc","copy":"styles_copy__7eCc3"};